import React from "react"
import styled from "styled-components"
import { color, breakpoint, transition } from "../../../configs/utilities"
import { Link } from "gatsby"

const ButtonLink = props => {
  return props.external ? (
    <ExternalLink
      href={props.to}
      target="_blank"
      rel="noopener noreferrer"
      download={props.download}
    >
      <ButtonStyle
        buttonBackground={props.buttonBackground}
        buttonTextColor={props.buttonTextColor}
      >
        {props.buttonText}
      </ButtonStyle>
    </ExternalLink>
  ) : (
    <InternalLink to={props.to}>
      <ButtonStyle
        buttonBackground={props.buttonBackground}
        buttonTextColor={props.buttonTextColor}
      >
        {props.buttonText}
      </ButtonStyle>
    </InternalLink>
  )
}

export default ButtonLink

const InternalLink = styled(Link)``

const ExternalLink = styled.a``

const ButtonStyle = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
  background: ${props => props.buttonBackground || color.white};
  color: ${props => props.buttonTextColor || color.black};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  text-transform: capitalize;
  border-radius: 8px;
  cursor: pointer;
  max-width: 500px;
  transition: ${transition.default};

  &:hover {
    opacity: 0.8;
  }

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 5vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 6px 10px;
    font-size: 16px;
    min-width: 100px;
    max-width: 350px;
  }
`
